"use strict";

exports.__esModule = true;
exports["default"] = exports.SliderWrapper = exports.Pretitle = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _gridSystem = _interopRequireDefault(require("../../utils/grid-system"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _toolsSlider = _interopRequireDefault(require("./tools-slider"));

var _header = _interopRequireDefault(require("./header"));

var _card = _interopRequireWildcard(require("./card"));

var _excluded = ["id"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Pretitle = _styledComponents["default"].span.withConfig({
  displayName: "recommended-tools__Pretitle",
  componentId: "sc-pingho-0"
})(["text-transform:uppercase;letter-spacing:4px;"]);

exports.Pretitle = Pretitle;
var SliderWrapper = (0, _styledComponents["default"])(_primitives["default"].Flex).withConfig({
  displayName: "recommended-tools__SliderWrapper",
  componentId: "sc-pingho-1"
})(["overflow:hidden;transform-style:preserve-3d;"]);
exports.SliderWrapper = SliderWrapper;
var ToolsComponentContainer = (0, _styledComponents["default"])(_gridSystem["default"].Wrapper).withConfig({
  displayName: "recommended-tools__ToolsComponentContainer",
  componentId: "sc-pingho-2"
})(["overflow:hidden;position:relative;> div{position:initial;}"]);
var CardContent = (0, _styledComponents["default"])(_gridSystem["default"].Element).withConfig({
  displayName: "recommended-tools__CardContent",
  componentId: "sc-pingho-3"
})(["padding:0;"]);
var propTypes = {
  /** Background color */
  backgroundColor: _propTypes.string,

  /** Background image */
  backgroundImage: _propTypes.string,

  /** setting for bottom padding amount * */
  bottomUnitPadding: _propTypes.number,

  /** html class name */
  className: _propTypes.string,

  /** Custom Background React component  */
  customBackground: _propTypes.func,

  /** A boolean to set whether the dark version of the cta is used */
  darkUi: _propTypes.bool,

  /** Custom html id used for targeting component */
  htmlId: _propTypes.string,

  /** Array of objs for Cta links */
  links: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    /** Defaults to an anchor tag if a url prop is present and a <button> tag otherwise */
    tag: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, _propTypes.node]),

    /** Target for cta links, used for opening a new tab or window */
    target: _propTypes.string,

    /** text prop is a children node for cta */
    text: _propTypes.node,

    /** Url provided to CtaContainer for links */
    url: _propTypes.string
  })),

  /** system Theme prop */
  theme: _utils.themePropType,

  /** Title text usually a text, but can be a React component  */
  title: _propTypes.node,

  /** Array of objs for ToolsCards */
  tools: (0, _propTypes.arrayOf)((0, _propTypes.shape)(_card.toolsCardPropTypes)),

  /** Setting for top padding amount * */
  topUnitPadding: _propTypes.number
};
var defaultProps = {
  backgroundColor: "background-ultra-light",
  bottomUnitPadding: 2,
  topUnitPadding: 2
};

var RecommendedTools = function RecommendedTools(_ref) {
  var backgroundColor = _ref.backgroundColor,
      backgroundImage = _ref.backgroundImage,
      bottomUnitPadding = _ref.bottomUnitPadding,
      topUnitPadding = _ref.topUnitPadding,
      tools = _ref.tools,
      className = _ref.className,
      customBackground = _ref.customBackground,
      title = _ref.title,
      darkUi = _ref.darkUi,
      htmlId = _ref.htmlId,
      links = _ref.links,
      theme = _ref.theme;
  var columnRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)({
    columnWidth: 1,
    openCard: null
  }),
      state = _useState[0],
      setState = _useState[1];

  var cardClickHandler = function cardClickHandler(index) {
    setState(Object.assign({}, state, {
      openCard: index
    }));
  };

  (0, _react.useEffect)(function () {
    var resizeHandler = function resizeHandler() {
      var columnWidth = state.columnWidth;
      var width = tools.length === 1 ? "100%" : columnRef.current.clientWidth;

      if (columnWidth !== width) {
        setState(Object.assign({}, state, {
          columnWidth: width
        }));
      }
    };

    var clickHandler = function clickHandler() {
      setState(Object.assign({}, state, {
        openCard: null
      }));
    }; // Fired on mount and update


    window.addEventListener("click", clickHandler);
    window.addEventListener("resize", resizeHandler);
    resizeHandler(); // Fired on unmounting

    return function cleanup() {
      window.removeEventListener("click", clickHandler);
      window.removeEventListener("resize", resizeHandler);
    };
  }, [state, tools]);
  var titleFont = {
    color: darkUi ? "text-light" : "text-title",
    fontSize: [6, 8],
    fontWeight: [1, 2],
    lineHeight: ["1.25", "1.19", "1.25", "1.25", "normal"],
    mb: 4,
    textAlign: "left"
  };
  return /*#__PURE__*/_react["default"].createElement(ToolsComponentContainer, {
    backgroundColor: backgroundColor,
    backgroundImage: backgroundImage,
    className: className,
    htmlId: htmlId,
    tag: customBackground
  }, /*#__PURE__*/_react["default"].createElement(_gridSystem["default"].Container, {
    alignItems: "center",
    flexDirection: ["column", "row"],
    justifyContent: "flex-start",
    pb: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return bottomUnitPadding * padding;
    }),
    pt: theme && theme.unitPadding && theme.unitPadding.map(function (padding) {
      return topUnitPadding * padding;
    }),
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_header["default"], {
    links: links,
    title: title,
    titleFont: titleFont
  }), /*#__PURE__*/_react["default"].createElement(CardContent, {
    className: className,
    columns: tools.length === 1 ? [6, 8, 12, 6, 6, 6] : [6, 8, 12, 9, 9, 9],
    flexDirection: "column",
    id: htmlId,
    justifyContent: "flex-start",
    mb: -24,
    mt: ["62px", 3, 5, -24]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: columnRef
  }, /*#__PURE__*/_react["default"].createElement(SliderWrapper, {
    pt: 3,
    width: tools.length === 1 ? null : 5000
  }, /*#__PURE__*/_react["default"].createElement(_toolsSlider["default"], {
    single: tools.length === 1,
    width: state.columnWidth
  }, (0, _utils.mapIndexed)(function (_ref2, index) {
    var id = _ref2.id,
        rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

    return /*#__PURE__*/_react["default"].createElement(_card["default"], _extends({
      key: id,
      clickHandler: cardClickHandler,
      index: index,
      isFlipped: index === state.openCard,
      single: tools.length === 1
    }, rest));
  }, tools)))))));
};

RecommendedTools.propTypes = propTypes;
RecommendedTools.defaultProps = defaultProps;
RecommendedTools.displayName = "Modules.RecommendedTools";

var _default = (0, _styledComponents.withTheme)(RecommendedTools);

exports["default"] = _default;